import { SAVE_DOSSIER } from './actionTypes'
import { DossierType } from './types'
import { DossierModel } from '../../../types/dossier/dossierModel'

export const saveDossier = (dossier: DossierModel | null): DossierType => {
	return ({
		type: SAVE_DOSSIER,
		payload: dossier
	})
}
